import React from "react";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";

import { Alert } from "reactstrap";

import { TextField, Button, Modal } from "@mui/material";
import { makeStyles } from '@mui/styles';

import {
  addComplianceAddons,
  clearAllGlobalLicenseMessages,
} from "../store/actions";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "whitesmoke",
  },
  activeButton: {
    color: "white", // change this to the desired active color
    marginLeft: "auto", // This will push the link to the right
    textDecoration: "none", // Remove text decoration from the link
  },
  logo: {
    maxWidth: 160,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "auto" /* Enable vertical scrolling */,
    maxHeight: "100vh" /* Set a maximum height to limit scrolling */,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

const ComplianceAddonsModal = (props) => {
  // console.log("ComplianceAddonsModal, props: ", props);
  // const existingAddons = props?.addons;
  // let initialAddons = existingAddons?.length > 0 ? existingAddons : [];
  // console.log("Initial addons = ", initialAddons);
  // const [addons, setAddons] = useState(initialAddons);
  const [addons, setAddons] = useState([]);

  const history = useHistory();

  const addAddon = () => {
    setAddons([...addons, { Name: "", Price: 0, Description: "" }]);
  };

  const deleteAddon = (index) => {
    const updatedAddons = [...addons];
    updatedAddons.splice(index, 1);
    setAddons(updatedAddons);
  };

  const handleModalClose = () => {
    props.setOpen(false);
  };

  //For displaying error for adding compliance addons
  let addComplianceAddonsErr = props.addComplianceAddonsError;
  useEffect(() => {
    if (addComplianceAddonsErr) {
      //Clear all messages after 10 seconds
      setTimeout(() => {
        props.clearAllMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [addComplianceAddonsErr, props]);

  //For dismissing modal of adding compliance addons
  let addComplianceAddonsMsg = props.addComplianceAddonsMessage;
  useEffect(() => {
    if (addComplianceAddonsMsg) {
      props.setOpen(false);
      history.go(0);
    }
  }, [addComplianceAddonsMsg, history, props]);

  const classes = useStyles();
  return (
    <Modal
      className={classes.modal}
      open={props.isOpen}
      onClose={handleModalClose}
    >
      <div className={classes.paper}>
        <h3>Customize Compliance Addons</h3>
        <div>
          {props.addComplianceAddonsError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while adding compliance addons.
              {JSON.stringify(props.addComplianceAddonsError?.message)}
            </Alert>
          )}
        </div>
        <div>
          {addons.map((addon, index) => (
            <div key={index} style={{ marginTop: "10px" }}>
              <TextField
                label="Name"
                size="small"
                value={addon.Name}
                onChange={(e) => {
                  const updatedAddons = [...addons];
                  updatedAddons[index].Name = e.target.value;
                  setAddons(updatedAddons);
                }}
              />
              <span> </span>
              <TextField
                label="Price"
                size="small"
                type="number"
                value={addon.Price}
                onChange={(e) => {
                  const updatedAddons = [...addons];
                  updatedAddons[index].Price = parseInt(e.target.value);
                  setAddons(updatedAddons);
                }}
              />
              <span> </span>
              <TextField
                label="Description"
                size="small"
                value={addon.Description}
                onChange={(e) => {
                  const updatedAddons = [...addons];
                  updatedAddons[index].Description = e.target.value;
                  setAddons(updatedAddons);
                }}
              />
              <span> </span>
              <Button onClick={() => deleteAddon(index)}>Delete</Button>
            </div>
          ))}
          <Button onClick={addAddon}>Add</Button>
        </div>

        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            props.addComplianceAddons(addons);
          }}
          disabled={props.isAddingComplianceAddons}
        >
          Add Addons
        </Button>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const {
    isAddingComplianceAddons,
    addComplianceAddonsError,
    addComplianceAddonsMessage,
  } = state.globalLicense;

  return {
    isAddingComplianceAddons,
    addComplianceAddonsError,
    addComplianceAddonsMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addComplianceAddons: (complianceAddons) =>
      dispatch(addComplianceAddons(complianceAddons)),
    clearAllMessages: () => dispatch(clearAllGlobalLicenseMessages()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ComplianceAddonsModal);